module.exports = __webpack_public_path__ + "static/media/horma-sandalia-y-sport.1ea92fbd.png";